import axios from "../utilities/api/axiosInstance";
import { printInConsole } from "@utils/devtools/utils";

export async function getEncyclopediaEvents({ date = 0 }) {
  let data = null,
    err = null;

  let URL = null;
  if (date === 0) URL = `festivalTimeline`;
  else URL = `festivalTimeline?date=${date}`;

  const reqOptions = {
    method: "GET",
    url: encodeURI(URL),
  };

  const response = await axios(reqOptions).catch((error) => {
    err = error;
  });

  printInConsole("getEncyclopediaEvents => ", response);

  if (response?.data?.success) data = response?.data?.response;
  else if (response?.data?.message) err = response.data.message;

  return { data, err };
}
